import React, { Component, useState } from 'react'
import CienciaAbertaService from '../services/CienciaAbertaService';

function NotFound() {
    return (

       <center><h1> Página não encontrada !!!</h1></center>

    );
}

export default NotFound;